module.exports = __webpack_public_path__ + "r-v3/img/stopwatch_menu_basic.2d2e3867.svg";